import { useEffect, useState } from "react";
import { Button, Form, Row } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import {
  DateInputField,
  InputField,
  SelectionField,
  TextAreaField,
  TimeInputField,
} from "../../../CommonElements";
import { getCurrentTime, getUser } from "../../../Utils/externalFunctions";
import { useAbsensi } from "../../../Context/AbsensiContext";

const AbsenForm = ({ resetState, toggle, staf, dateFilter, create }) => {
  const absensiAPI = useAbsensi();
  const { control, handleSubmit } = useForm({
    defaultValues: {
      ...staf?.absen,
      id_user: staf?.nama,
      tanggal: dateFilter,
      id_user_pencatat: getUser(),
      source: 1,
      jam_datang: staf?.datang?.jam || getCurrentTime(),
      id_lokasi_datang: staf?.datang?.id_lokasi,
      jam_pulang: staf?.pulang?.jam || (staf?.datang?.jam ? getCurrentTime() : null ),
      id_lokasi_pulang: staf?.pulang?.id_lokasi,
      id_tipe_absensi: staf?.absen?.id_tipe_absensi || "Hadir",
    },
  });

  const [tipeAbsensi, setTipeAbsensi] = useState([]);

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      absensiAPI.getTipeAbsensi().then((res) => {
        setTipeAbsensi(res.data || []);
      });
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  const createItem = (data) => {
    absensiAPI.createAbsensi(data).then(() => {
      if (typeof resetState === 'function') {
        resetState();
      }
      toggle();
    });
  };

  const updateItem = (data) => {
    absensiAPI.updateAbsensi(data.id_absensi, data).then(() => {
      if (typeof resetState === 'function') {
        resetState();
      }
      toggle();
    });
  };

  const lokasiOptions = [
    { id: 3, name: "Gedung C" },
    { id: 4, name: "Gedung A (Satpam)" },
    { id: 5, name: "Gedung A (Mesin Fotocopy)" },
    { id: 6, name: "Gedung Baru" },
    { id: 7, name: "Salemba" },
  ];

  return (
    <Form
      onSubmit={
        staf?.absen ? handleSubmit(updateItem) : handleSubmit(createItem)
      }
    >
      <Row className={"row-cols-2"}>
        <Controller
          name="id_user"
          control={control}
          render={({ field, fieldState }) => (
            <InputField
              label={"Nama"}
              fieldState={fieldState}
              {...field}
              disabled
            />
          )}
        />
        <Controller
          name="tanggal"
          control={control}
          render={({ field, fieldState }) => (
            <DateInputField
              label={"Tanggal"}
              fieldState={fieldState}
              {...field}
              disabled
            />
          )}
        />
      </Row>
      <Row className={"row-cols-2"}>
        <Controller
          name="jam_datang"
          control={control}
          render={({ field, fieldState }) => (
            <TimeInputField
              label={"Absen Datang"}
              fieldState={fieldState}
              {...field}
            />
          )}
        />
        <Controller
          name="id_lokasi_datang"
          control={control}
          render={({ field, fieldState }) => (
            <SelectionField
              className={"col-6"}
              label={"Lokasi Datang"}
              placeholder={"-- select lokasi datang --"}
              defaultValues={!create ? staf?.datang?.id_lokasi : null}
              options={lokasiOptions}
              fieldState={fieldState}
              {...field}
            />
          )}
        />
        <Controller
          name="jam_pulang"
          control={control}
          render={({ field, fieldState }) => (
            <TimeInputField
            label={"Absen Keluar"}
            fieldState={fieldState}
            {...field}
            />
          )}
        />
        <Controller
          name="id_lokasi_pulang"
          control={control}
          render={({ field, fieldState }) => (
            <SelectionField
              className={"col-6"}
              label={"Lokasi pulang"}
              placeholder={"-- select lokasi pulang --"}
              defaultValues={!create ? staf?.pulang?.id_lokasi : null}
              options={lokasiOptions}
              fieldState={fieldState}
              {...field}
            />
          )}
        />
      </Row>
      <Row>
        <Controller
          name="id_tipe_absensi"
          control={control}
          render={({ field, fieldState }) => (
            <SelectionField
              className={"col-12"}
              label={"Tipe Absensi"}
              placeholder={"-- select tipe absensi --"}
              defaultValues={staf?.absen?.id_tipe_absensi || "Hadir"}
              options={(tipeAbsensi || []).map((row) => ({
                id: row.nama_tipe_absensi,
                name: row.nama_tipe_absensi,
              }))}
              fieldState={fieldState}
              {...field}
            />
          )}
        />
        <Controller
          name="keterangan"
          control={control}
          render={({ field, fieldState }) => (
            <TextAreaField
              label={"Keterangan"}
              defaultValues={!create && staf?.absen?.keterangan}
              fieldState={fieldState}
              {...field}
            />
          )}
        />
      </Row>

      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default AbsenForm;